"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const react_css_themr_1 = require("react-css-themr");
function DumpFormItem({ name, label, helpText, errorText, successText, children, theme = {}, }) {
    return (React.createElement("div", { className: theme.root },
        React.createElement("div", { className: theme.labelWrapper },
            React.createElement("label", { className: theme.label, htmlFor: name }, label)),
        React.createElement("div", { className: theme.inputWrapper }, children),
        !errorText &&
            helpText && (React.createElement("div", { className: theme.helpTextWrapper },
            React.createElement("div", { className: theme.helpText }, helpText))),
        errorText && (React.createElement("div", { className: theme.errorTextWrapper },
            React.createElement("div", { className: theme.errorText }, errorText))),
        successText && (React.createElement("div", { className: theme.successTextWrapper },
            React.createElement("div", { className: theme.successText }, successText)))));
}
exports.defaultFormItemTheme = {
    root: 'flex flex-column mb3',
    label: 'w-100 pv1',
    inputWrapper: 'w-100 pv2 ph0 bb b--gray',
    input: '',
    helpTextWrapper: 'pa2',
    helpText: 'f7 gray i',
    successTextWrapper: 'pa2',
    successText: 'f7 green',
    errorTextWrapper: 'pa2',
    errorText: 'f7 red',
};
exports.default = react_css_themr_1.themr('FormItem', {}, { composeTheme: 'softly' })(DumpFormItem);
//# sourceMappingURL=index.js.map